import { isSIREN, isSIRET } from '@shinetools/vat-siren-siret';
import { z } from 'zod';

import { isSirenLike } from '../../utils/hybridSiretUtils';
import locales from './locales';

/**
 * This schema represents a user's input to search their company.
 * If we infer the user is searching by SIREN or SIRET, we validate its shape.
 * Else, we only care about having a minimum character length.
 */
export const searchSchema = z.object({
  searchInput: z
    .string()
    .min(2, locales.errors.min)
    .refine((value) => {
      if (!value) {
        return true;
      }
      if (!isSirenLike(value)) {
        return true;
      }
      return isSIRET(value) || isSIREN(value);
    }, locales.errors.siretInvalid),
});
